import Vue from 'vue';
import Audio from './Audio.vue';
import SvgIcon from '../../common/Icon.vue';
Vue.component('svg-icon', SvgIcon);

export default (props) => {
  /**
   * props中的字段
   * url 音频的源链接,
   * duration 音频的时长,
   * attachmentId 音频附件ID,
   * text 语音转文字内容
   * env 当前环境
   */
  const Constructor = Vue.extend(Audio);
  const { url = '', attachmentId = '', duration = '', text = '', filename = '', description = '' } = props;
  const component = new Constructor({
    propsData: {
      ...props
    },
    data: {
      url,
      duration,
      attachmentId,
      text,
      filename,
      description
    }
  });
  return { component };
};
